import { render, staticRenderFns } from "./FieldErrorItem.vue?vue&type=template&id=b1f24844&scoped=true&"
import script from "./FieldErrorItem.vue?vue&type=script&lang=js&"
export * from "./FieldErrorItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=b1f24844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f24844",
  null
  
)

export default component.exports